export default class ImpressionSlider {

  constructor(el) {
    this.$el = el;
    this.$swipers = this.$el.querySelectorAll(".swiper");
    this.$swipers.forEach(s => {
      this.initSwiper(s);
    });
  }

  initSwiper(s) {

    const swiper = new Swiper(s, {
      speed: 1600,
      loop: true,
      autoplay: {
        delay: 3000,
        reverseDirection: s.classList.contains('reverse') ? true : false,
        disableOnInteraction: false,
      },
      centeredSlides: true,
      grabCursor: true,
      slidesPerView: 1.5,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1500: {
          slidesPerView: 3.5,
          spaceBetween: 32,
        },
        1920: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
        2560: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
      },
    });

    return swiper

  }
}
